const jsNiceSelects = document.querySelectorAll('.js-nice-select');

if(jsNiceSelects) {
    for (const selectNode of jsNiceSelects) {
        selectNode.addEventListener('change', function (e) {
            e.preventDefault();
    
            const elem = e.currentTarget;
            const niceSelectWrapper = elem.parentElement;
            const niceSelectText = niceSelectWrapper.querySelector('.niceselect-text');
            const text = selectNode.options[selectNode.selectedIndex].text;
    
            niceSelectText.innerHTML = text;
        });
    }
}